import { GlobalStatus, StatusEnum } from "@gtpl/shared-models/common-models";
import { Column, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn, OneToOne } from "typeorm";
import { SaleOrder } from "./sale-order.entitiy";

@Entity('bom_details')
export class BomDetails {

  @PrimaryGeneratedColumn("increment", { name: 'packing_material_id' })
  packingMaterialId: number;

  @Column("int", {
    nullable: false,
    name: "item_category_id"
  })
  itemCategoryId: number;

  @Column("int", {
    nullable: false,
    name: "item_sub_category_id"
  })
  itemSubCategoryId: number;

  @Column("int", {
    nullable: false,
    name: "sale_order_id"
  })
  saleOrderId: number;

  @Column("int", {
    nullable: true,
    name: "item_id"
  })
  itemId: number;

  @Column("int", {
    nullable: true,
    name: "size"
  })
  size: number;

  @Column("varchar", {
    nullable: true,
    length:30,
    name: "packing_category"
  })
  packingCategory: string;


  @Column({
    type:"decimal",
    precision:10,
    scale:3,
    nullable: true,
    name: "quantity",
    default:0,
    unsigned:true
  })
  quantity: number;

  @Column({
    type:"decimal",
    precision:10,
    scale:3,
    nullable: true,
    name: "existing_qty",
    default:0,
    unsigned:true
  })
  avilableQuantity: number;

  @Column({
    type:"enum",
    enum: StatusEnum,
    default:StatusEnum.OPEN,
    nullable: true,
    name: "status"
  })
  status: StatusEnum;
  @Column({
    type: 'enum',
    enum : GlobalStatus,
    nullable: true,
    name: 'is_qty_revised',
    default:GlobalStatus.NO
})
isQtyRevised : GlobalStatus;
@Column({
  type: 'enum',
  enum : GlobalStatus,
  nullable: true,
  name: 'is_active_revised',
  default:GlobalStatus.NO
})
isActiveRevised : GlobalStatus;

@Column({
  type: 'enum',
  enum : GlobalStatus,
  nullable: true,
  name: 'is_required',
  default:GlobalStatus.NO
})
isRequired : GlobalStatus;

  @Column({
    type:"decimal",precision:10,scale:3,
    nullable: true,
    default:0,
    name: "required_qty",
    unsigned:true
  })
  requiredQuantity: number;

  @Column({
    type:"decimal",precision:10,scale:3,
    nullable: true,
    default:0,
    name: "receiced_qty",
    unsigned:true
  })
  receivedQuantity: number;

  @Column({
    type:"decimal",precision:10,scale:3,
    nullable: true,
    default:0,
    name: "po_qty",
    unsigned:true
  })
  poQty: number;

  @Column({
    type:"decimal",precision:10,scale:3,
    nullable: true,
    default:0,
    name: "assigned_qty",
    unsigned:true
  })
  AssignedQuantity: number;

  @Column("boolean", {
    nullable: false,
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
	default:"Admin",
    name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;

  @ManyToOne(type=>SaleOrder, saleOrder=>saleOrder.BomDetailsInfo, {  nullable:false })
  @JoinColumn({ name:"sale_order_id"})
  saleOrderInfo: SaleOrder;
}
